import {AdapterProps, FieldAdapter} from '../field-factory';
import {Textarea, TextareaProps} from '@mantine/core';
import {FC, useContext} from 'react';
import {ReadOnlyContext} from '../readonly-context';

export type $TextAreaAdapterProps = AdapterProps<TextareaProps>;

export const $TextAreaAdapter: FC<FieldAdapter<$TextAreaAdapterProps>> = ({
  inputProps: {disabled, onChange, ...inputProps},
  control,
}) => {
  const {readOnly} = useContext(ReadOnlyContext);
  const {
    field: {onChange: fieldOnChange, ...fieldProps},
    fieldState: {invalid},
  } = control;

  const _onChange: TextareaProps['onChange'] = (e) => {
    fieldOnChange(e);
    onChange?.(e);
  };

  return (
    <Textarea
      error={invalid}
      disabled={disabled || readOnly}
      onChange={_onChange}
      {...fieldProps}
      {...inputProps}
    />
  );
};